

// // // // // export default DealCountdown;
// // // // import React, { useEffect, useState } from "react";

// // // // const DealCountdown = () => {
// // // //   const campaignEnd = new Date();
// // // //   campaignEnd.setHours(campaignEnd.getHours() + 18);
// // // //   campaignEnd.setMinutes(campaignEnd.getMinutes() + 14);
// // // //   campaignEnd.setSeconds(campaignEnd.getSeconds() + 56);

// // // //   const calculateTimeLeft = () => {
// // // //     const diff = +campaignEnd - +new Date();
// // // //     return diff > 0
// // // //       ? {
// // // //           hours: String(Math.floor((diff / (1000 * 60 * 60)) % 24)).padStart(2, "0"),
// // // //           minutes: String(Math.floor((diff / 1000 / 60) % 60)).padStart(2, "0"),
// // // //           seconds: String(Math.floor((diff / 1000) % 60)).padStart(2, "0"),
// // // //         }
// // // //       : { hours: "00", minutes: "00", seconds: "00" };
// // // //   };

// // // //   const [timeLeft, setTimeLeft] = useState(calculateTimeLeft());

// // // //   useEffect(() => {
// // // //     const timer = setInterval(() => {
// // // //       setTimeLeft(calculateTimeLeft());
// // // //     }, 1000);
// // // //     return () => clearInterval(timer);
// // // //   }, []);

// // // //   return (
// // // //     <div
// // // //       className="w-full md:px-0 px-4 py-5 text-white shadow-md md:rounded-none"
// // // //       style={{
// // // //         backgroundColor: "#0a0a0a",
// // // //         boxShadow: "0 0 12px rgba(0, 0, 0, 0.4)",
// // // //       }}
// // // //     >
// // // //       <div className="max-w-6xl mx-auto text-center">
// // // //         <h2 className="text-[18px] md:text-xl font-bold mb-1 leading-tight">
// // // //           Get a Price Now, Instantly Save <span className="text-green-400">25%</span>!
// // // //         </h2>

// // // //         <p className="text-sm text-gray-300 mb-2">
// // // //           Best Price: Only <span className="text-green-500 font-semibold">€25</span>
// // // //         </p>

// // // //         <div className="flex justify-center gap-4 font-mono text-[15px] mt-2">
// // // //           <div>
// // // //             <span className="text-white font-bold text-[17px]">{timeLeft.hours}</span>{" "}
// // // //             <span className="text-gray-400 text-[13px]">hours</span>
// // // //           </div>
// // // //           <div>
// // // //             <span className="text-white font-bold text-[17px]">{timeLeft.minutes}</span>{" "}
// // // //             <span className="text-gray-400 text-[13px]">minutes</span>
// // // //           </div>
// // // //           <div>
// // // //             <span className="text-white font-bold text-[17px]">{timeLeft.seconds}</span>{" "}
// // // //             <span className="text-gray-400 text-[13px]">seconds</span>
// // // //           </div>
// // // //         </div>

// // // //         {/* <p className="text-[11px] text-gray-400 mt-3 italic">
// // // //           * Prices are per vehicle, not per person.
// // // //         </p> */}
// // // //       </div>
// // // //     </div>
// // // //   );
// // // // };

// // // // export default DealCountdown;
// // // // // 
// // // import React, { useEffect, useState } from "react";

// // // const DealCountdown = () => {
// // //   const campaignEnd = new Date();
// // //   campaignEnd.setHours(campaignEnd.getHours() + 18);
// // //   campaignEnd.setMinutes(campaignEnd.getMinutes() + 14);
// // //   campaignEnd.setSeconds(campaignEnd.getSeconds() + 56);

// // //   const calculateTimeLeft = () => {
// // //     const diff = +campaignEnd - +new Date();
// // //     return diff > 0
// // //       ? {
// // //           hours: String(Math.floor((diff / (1000 * 60 * 60)) % 24)).padStart(2, "0"),
// // //           minutes: String(Math.floor((diff / 1000 / 60) % 60)).padStart(2, "0"),
// // //           seconds: String(Math.floor((diff / 1000) % 60)).padStart(2, "0"),
// // //         }
// // //       : { hours: "00", minutes: "00", seconds: "00" };
// // //   };

// // //   const [timeLeft, setTimeLeft] = useState(calculateTimeLeft());
// // //   useEffect(() => {
// // //     const timer = setInterval(() => setTimeLeft(calculateTimeLeft()), 1000);
// // //     return () => clearInterval(timer);
// // //   }, []);

// // //   return (
// // //     <div
// // //       className="w-[95%] mx-auto px-3 py-2 text-white rounded-md -mb-1"
// // //       style={{ backgroundColor: "#0a0a0a", boxShadow: "0 0 10px rgba(0,0,0,0.35)" }}
// // //     >
// // //       <div className="text-center leading-tight">
// // //         <h2 className="text-[15px] md:text-lg font-bold mb-0.5 leading-snug">
// // //           Get a Price Now, Instantly Save <span className="text-green-400">25%</span>!
// // //         </h2>

// // //         <p className="text-[11px] text-gray-300 mb-1 leading-snug">
// // //           Best Price: Only <span className="text-green-500 font-semibold">€25</span>
// // //         </p>

// // //         <div className="flex justify-center gap-3 font-mono text-[12px] leading-none">
// // //           <div>
// // //             <span className="text-white font-bold text-[15px]">{timeLeft.hours}</span>{" "}
// // //             <span className="text-gray-400 text-[11px]">hours</span>
// // //           </div>
// // //           <div>
// // //             <span className="text-white font-bold text-[15px]">{timeLeft.minutes}</span>{" "}
// // //             <span className="text-gray-400 text-[11px]">minutes</span>
// // //           </div>
// // //           <div>
// // //             <span className="text-white font-bold text-[15px]">{timeLeft.seconds}</span>{" "}
// // //             <span className="text-gray-400 text-[11px]">seconds</span>
// // //           </div>
// // //         </div>
// // //       </div>
// // //     </div>
// // //   );
// // // };

// // // export default DealCountdown;
// // import React, { useEffect, useState } from "react";

// // const DealCountdown = () => {
// //   const campaignEnd = new Date();
// //   campaignEnd.setHours(campaignEnd.getHours() + 18);
// //   campaignEnd.setMinutes(campaignEnd.getMinutes() + 14);
// //   campaignEnd.setSeconds(campaignEnd.getSeconds() + 56);

// //   const calculateTimeLeft = () => {
// //     const diff = +campaignEnd - +new Date();
// //     return diff > 0
// //       ? {
// //           hours: String(Math.floor((diff / (1000 * 60 * 60)) % 24)).padStart(2, "0"),
// //           minutes: String(Math.floor((diff / 1000 / 60) % 60)).padStart(2, "0"),
// //           seconds: String(Math.floor((diff / 1000) % 60)).padStart(2, "0"),
// //         }
// //       : { hours: "00", minutes: "00", seconds: "00" };
// //   };

// //   const [timeLeft, setTimeLeft] = useState(calculateTimeLeft());
// //   useEffect(() => {
// //     const timer = setInterval(() => setTimeLeft(calculateTimeLeft()), 1000);
// //     return () => clearInterval(timer);
// //   }, []);

// //   return (
// //     <div
// //       className="w-[95%] mx-auto px-3 py-2 text-white rounded-md -mb-1"
// //       style={{ backgroundColor: "#0a0a0a", boxShadow: "0 0 10px rgba(0,0,0,0.35)" }}
// //     >
// //       {/* İÇ KUTU: daha açık fon + ring + gölge (dikey padding YOK → yükseklik aynı) */}
// //       <div className="rounded-md bg-[#162033]/90 ring-1 ring-white/10 shadow-[0_8px_20px_rgba(0,0,0,0.45)] px-2">
// //         <div className="text-center leading-tight">
// //           <h2 className="text-[15px] md:text-lg font-bold mb-0.5 leading-snug">
// //             Get a Price Now, Instantly Save <span className="text-green-400">25%</span>!
// //           </h2>

// //           <p className="text-[11px] text-gray-300 mb-1 leading-snug">
// //             Best Price: Only <span className="text-green-500 font-semibold">€25</span>
// //           </p>

// //           <div className="flex justify-center gap-3 font-mono text-[12px] leading-none">
// //             <div>
// //               <span className="text-white font-bold text-[15px]">{timeLeft.hours}</span>{" "}
// //               <span className="text-gray-400 text-[11px]">hours</span>
// //             </div>
// //             <div>
// //               <span className="text-white font-bold text-[15px]">{timeLeft.minutes}</span>{" "}
// //               <span className="text-gray-400 text-[11px]">minutes</span>
// //             </div>
// //             <div>
// //               <span className="text-white font-bold text-[15px]">{timeLeft.seconds}</span>{" "}
// //               <span className="text-gray-400 text-[11px]">seconds</span>
// //             </div>
// //           </div>
// //         </div>
// //       </div>
// //     </div>
// //   );
// // };

// // export default DealCountdown;
// import React, { useEffect, useState } from "react";

// const DealCountdown = () => {
//   const campaignEnd = new Date();
//   campaignEnd.setHours(campaignEnd.getHours() + 18);
//   campaignEnd.setMinutes(campaignEnd.getMinutes() + 14);
//   campaignEnd.setSeconds(campaignEnd.getSeconds() + 56);

//   const calculateTimeLeft = () => {
//     const diff = +campaignEnd - +new Date();
//     return diff > 0
//       ? {
//           hours: String(Math.floor((diff / (1000 * 60 * 60)) % 24)).padStart(2, "0"),
//           minutes: String(Math.floor((diff / 1000 / 60) % 60)).padStart(2, "0"),
//           seconds: String(Math.floor((diff / 1000) % 60)).padStart(2, "0"),
//         }
//       : { hours: "00", minutes: "00", seconds: "00" };
//   };

//   const [timeLeft, setTimeLeft] = useState(calculateTimeLeft());
//   useEffect(() => {
//     const timer = setInterval(() => setTimeLeft(calculateTimeLeft()), 1000);
//     return () => clearInterval(timer);
//   }, []);

//   return (
//     <div
//       // ▼ Quick Reservation ile aynı genişlik
//       className="w-[98vw] mx-auto px-2 py-2 text-white text-center rounded-2xl -mb-1"
//       style={{ backgroundColor: "#0a0a0a", boxShadow: "0 0 10px rgba(0,0,0,0.35)" }}
//     >
//       {/* İç kutu: daha açık fon + gölge; dikey padding YOK → yükseklik değişmez */}
//       <div className="rounded-xl bg-[#162033]/90 ring-1 ring-white/10 shadow-[0_8px_20px_rgba(0,0,0,0.45)] px-2">
//         <div className="text-center leading-tight">
//           <h2 className="text-[15px] md:text-lg font-bold mb-0.5 leading-snug">
//             Get a Price Now, Instantly Save <span className="text-green-400">25%</span>!
//           </h2>

//           <p className="text-[11px] text-gray-300 mb-1 leading-snug">
//             Best Price: Only <span className="text-green-500 font-semibold">€25</span>
//           </p>

//           <div className="flex justify-center gap-3 font-mono text-[12px] leading-none">
//             <div>
//               <span className="text-white font-bold text-[15px]">{timeLeft.hours}</span>{" "}
//               <span className="text-gray-400 text-[11px]">hours</span>
//             </div>
//             <div>
//               <span className="text-white font-bold text-[15px]">{timeLeft.minutes}</span>{" "}
//               <span className="text-gray-400 text-[11px]">minutes</span>
//             </div>
//             <div>
//               <span className="text-white font-bold text-[15px]">{timeLeft.seconds}</span>{" "}
//               <span className="text-gray-400 text-[11px]">seconds</span>
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default DealCountdown;
import React, { useEffect, useState } from "react";

const DealCountdown = () => {
  const campaignEnd = new Date();
  campaignEnd.setHours(campaignEnd.getHours() + 18);
  campaignEnd.setMinutes(campaignEnd.getMinutes() + 14);
  campaignEnd.setSeconds(campaignEnd.getSeconds() + 56);

  const calculateTimeLeft = () => {
    const diff = +campaignEnd - +new Date();
    return diff > 0
      ? {
          hours: String(Math.floor((diff / (1000 * 60 * 60)) % 24)).padStart(2, "0"),
          minutes: String(Math.floor((diff / 1000 / 60) % 60)).padStart(2, "0"),
          seconds: String(Math.floor((diff / 1000) % 60)).padStart(2, "0"),
        }
      : { hours: "00", minutes: "00", seconds: "00" };
  };

  const [timeLeft, setTimeLeft] = useState(calculateTimeLeft());
  useEffect(() => {
    const timer = setInterval(() => setTimeLeft(calculateTimeLeft()), 1000);
    return () => clearInterval(timer);
  }, []);

  return (
    <div
      // ▼ Ortalamak için: w-full + mx-auto (ebeveyn px-3 ile aynı hizada)
      className="w-full mx-auto px-3 py-2 text-white rounded-lg -mb-1"
      style={{ backgroundColor: "#0a0a0a", boxShadow: "0 0 10px rgba(0,0,0,0.35)" }}
    >
      {/* İç kutu: açık fon + gölge; yükseklik değişmez */}
      <div className="rounded-xl bg-[#162033]/90 ring-1 ring-white/10 shadow-[0_8px_20px_rgba(0,0,0,0.45)] px-2">
        <div className="text-center leading-tight">
          <h2 className="text-[15px] md:text-lg font-bold mb-0.5 leading-snug">
            Get a Price Now, Instantly Save <span className="text-green-400">25%</span>!
          </h2>

          <p className="text-[11px] text-gray-300 mb-1 leading-snug">
            Best Price: Only <span className="text-green-500 font-semibold">€25</span>
          </p>

          <div className="flex justify-center gap-3 font-mono text-[12px] leading-none">
            <div>
              <span className="text-white font-bold text-[15px]">{timeLeft.hours}</span>{" "}
              <span className="text-gray-400 text-[11px]">hours</span>
            </div>
            <div>
              <span className="text-white font-bold text-[15px]">{timeLeft.minutes}</span>{" "}
              <span className="text-gray-400 text-[11px]">minutes</span>
            </div>
            <div>
              <span className="text-white font-bold text-[15px]">{timeLeft.seconds}</span>{" "}
              <span className="text-gray-400 text-[11px]">seconds</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DealCountdown;
